export default __webpack_public_path__ + "static/media/screen7.d5ca491e.png";